export default __webpack_public_path__ + "static/media/sidebar-4.7eeab558.jpg";